module.exports = "<div class=\" app-container\">\n\n    <!-- Content -->\n    <div class=\"content\">\n        <router-outlet></router-outlet>\n    </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main